/** Список должностей в форме регистрации (AuthForm) — то же для создания учётки из структуры. */
export const REGISTRATION_DEPARTMENT_OPTIONS = [
  'Организатор фотосессий',
  'Супервайзер колл-центра',
  'Менеджер отдела возвратов',
  'Менеджер склада',
  'Оператор колл-центра',
  'Менеджер отдела продаж',
  'Финансовый менеджер',
  'ОТК (отдел технического контроля)',
  'SMM-менеджер',
  'Водитель',
  'Менеджер по дропшиппингу',
  'Менеджер по качеству обслуживания клиентов',
  'Менеджер маркетплейса',
  'Бухгалтер по первичной документации',
  'Руководитель отдела закупок',
  'Супервайзер отдела возвратов',
  'CEO (генеральный директор)',
  'Контент-менеджер',
  'Завсклад (заведующий складом)',
  'Системный администратор',
  'Владелец компании',
  'Помощник SMM-менеджера',
  'Руководитель отдела логистики',
  'HR-менеджер (менеджер по персоналу)',
  'Менеджер отдела маркетинга',
  'Менеджер отдела закупок',
  'CFO (финансовый директор)',
  'Оператор-учётчик',
];
